import RmaDetails from './ui/rmaDetails';

export default RmaDetails;
